import classes from 'classnames'
import styles from './index.module.css'
import { useChat } from 'components/ChatWidget'

const ChatLink = ({ text, className }) => {
  const { open } = useChat()

  return (
    <span
      className={classes(styles.link, className)}
      onClick={open}
      role="button"
      tabIndex={0}>
      {text}
    </span>
  )
}

export default ChatLink
